export default __webpack_public_path__ + "static/media/island_1_with_objects.973e1e50.png";